import { ComponentType } from 'react'
import {
  IconAI,
  IconPrice,
  IconStructure,
  IconUseCase,
} from './DifferenceSolutionIcons'

export type DifferenceSolutionDataType = {
  title: string
  features: DifferenceSolutionFeature[]
}

type DifferenceSolutionFeature = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Icon: ComponentType<any>
  description: string
}

export const differenceSolutionData: DifferenceSolutionDataType[] = [
  {
    title: 'Architecture that scales',
    features: [
      {
        Icon: IconAI,
        description:
          'Integrates with anything that has an API by letting Al do all the hard work.',
      },
      {
        Icon: IconUseCase,
        description:
          'Works for any use case, from one-click integrations to integration platforms',
      },
    ],
  },
  {
    title: 'Pricing that scales',
    features: [
      {
        Icon: IconStructure,
        description: 'Pricing structure that matches your business model',
      },
      {
        Icon: IconPrice,
        description: 'Capped price that does not grow out of control',
      },
    ],
  },
]
